import React, { useState } from "react";
import { Stack, Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import CustomBreadCrumb from "../CustomBreadCrumb";
import TutorialVideoModal from "../../Modals/TutorialVideoModal";

import {
  RootWrapper,
  IconImg,
  ContentStack,
  ContentColumn,
  ContentGapBox,
  BackIconButton,
  TitleText,
  BodyText,
  VideoSection,
  VideoIframe,
  VideoLinkText,
  VideoLinkSpan,
  LinkContainer,
  SessionToggleButton,
} from "./PageTitle.styles";


const PageTitle = ({
  isUpcomingSession = true,
  textAsLink = false,
  setIsUpcomingSession = () => {},
  title,
  text,
  icon,
  noIcon = false,
  breadCrumb,
  breadCrumbOnClick,
  back = false,
  onBackClick,
  videoUrl,
}) => {
  const [videoModal, setVideoModal] = useState(false);
  const setUpcomingSessionHandler = (status) => () => setIsUpcomingSession(status);

  return (
    <RootWrapper>
      <TutorialVideoModal
        open={videoModal}
        handleClose={() => setVideoModal(false)}
        videoUrl={videoUrl}
      />
      <ContentStack spacing={2}>
        <ContentGapBox>
          <ContentColumn>
            <Stack direction="row" spacing={2}>
              {back && (
                <BackIconButton onClick={onBackClick}>
                  <ArrowBack />
                </BackIconButton>
              )}
              {!noIcon && <IconImg src={icon} alt="logo" />}
              <Box>
                <TitleText>{title}</TitleText>
                <CustomBreadCrumb
                  text={title}
                  breadCrumb={breadCrumb}
                  breadCrumbOnClick={breadCrumbOnClick}
                />
              </Box>
            </Stack>
            {textAsLink ?
              <LinkContainer>
                <SessionToggleButton
                  type="button"
                  onClick={setUpcomingSessionHandler(true)}
                  aria-pressed={isUpcomingSession}
                >
                  <BodyText component="span" active={isUpcomingSession}>
                    {text}
                  </BodyText>
                </SessionToggleButton>
                <span>/</span>
                <SessionToggleButton
                  type="button"
                  onClick={setUpcomingSessionHandler(false)}
                  aria-pressed={!isUpcomingSession}
                >
                  <BodyText component="span" active={!isUpcomingSession}>
                    Past Sessions
                  </BodyText>
                </SessionToggleButton>
              </LinkContainer>
              :
              <BodyText dangerouslySetInnerHTML={{ __html: text || "" }} />
            }
          </ContentColumn>

          {videoUrl && (
            <VideoSection onClick={() => setVideoModal(true)}>
              <VideoIframe src={videoUrl} title="Video" />
              <VideoLinkText>
                Click here{" "}
                <VideoLinkSpan component="span">
                  to get more details.
                </VideoLinkSpan>
              </VideoLinkText>
            </VideoSection>
          )}
        </ContentGapBox>
      </ContentStack>
    </RootWrapper>
  );
};

export default PageTitle;
